<template>
    <div class="text danger mt-4">
        <div><b>Внимание!!!</b> Все транзакции проходят <b class="text-danger">AML-проверку!</b></div>
        <div>В случае отправки высоко рискованных активов, ваш депозит может быть заморожен, на не определенный срок, для проведения дополнительной проверки.</div>
    </div>
</template>